import React from "react";
import { Star } from "lucide-react";

export default function TestimonialsSection({ testimonials }) {
  return (
    <section className="py-24 md:py-32 bg-[#faf3e3]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[12px] tracking-tight-wide text-[#a08862] font-semibold">
            {testimonials.eyebrow}
          </p>
          <h2 className="font-serif-display text-4xl md:text-6xl text-[#2a2a2a] mt-4">
            {testimonials.title}
          </h2>
          <div className="divider-line" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.items.map((t) => (
            <div
              key={t.id}
              className="bg-[#f5ebd6] p-7 text-center transition-transform duration-300 hover:-translate-y-1"
            >
              <img
                src={t.avatar}
                alt={t.name}
                className="w-20 h-20 rounded-full mx-auto object-cover ring-2 ring-[#a08862]/30"
              />
              <h4 className="font-serif-display text-xl text-[#2a2a2a] mt-4">
                {t.name}
              </h4>
              <p className="text-xs text-[#8a8a8a] mt-1">{t.when}</p>
              <div className="flex justify-center gap-1 mt-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star
                    key={i}
                    size={16}
                    className="text-[#d4a44a]"
                    fill="#d4a44a"
                  />
                ))}
              </div>
              <p className="text-sm text-[#5a5a5a] leading-relaxed mt-4 italic">
                “{t.text}”
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href={testimonials.reviewLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block border border-[#a08862] hover:bg-[#a08862] hover:text-white text-[#a08862] text-[12px] tracking-tight-wide px-9 py-4 transition-colors duration-300"
          >
            LEAVE A REVIEW ON GOOGLE
          </a>
        </div>
      </div>
    </section>
  );
}
